import { cnl } from "src/c8-platform/type/value";
import { Button, GridRow, ModalDialog } from "designSystem/index";
import { ButtonEnum } from "designSystem/types/button-types";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useSnapshotTemplateStore } from "../SnapshotTemplateStore";
import { AutoPopulateOptions, FOOTER_BUTTONS, HIDE_OVERFLOW } from "../snapshotUtils";
import TemplateForm from "../templateForm/TemplateForm";
import SnapshotTemplateDialogStore, { SnapshotTemplateDialogStoreContext } from "./SnapshotTemplateDialogStore";

interface SnapshotTemplateDialogProps extends AutoPopulateOptions {
	/** Flag that the template has been launched from copy action*/
	isCopyTemplate?: boolean;

	/** determine if modal should be open */
	open?: boolean;
	
	/** template id to edit */
	selectedTemplate?: cnl;

	/** Dialog store coming from the controller or from Generate Images (Save as New) */
	store?: SnapshotTemplateDialogStore;
}

const SaveAndCancel: FunctionComponent = observer(() => {
	const { 
		saveNewTemplate,
		dialogStore: {
			canSaveStyleSnapshotTemplate,
			onCancel,
		}, 
	} = useSnapshotTemplateStore();

	return (
		<GridRow
			justifyContent="flex-end"
			spacing={2}
			sx={FOOTER_BUTTONS}
		>
			<Button
				design="primary"
				disabled={!canSaveStyleSnapshotTemplate}
				onClick={saveNewTemplate}
				res={ButtonEnum.BUTTON_SAVE}
			/>
			<Button
				design="link"
				fullWidth
				onClick={onCancel}
				res={ButtonEnum.BUTTON_CANCEL}
			/>
		 </GridRow>
	);
});

const NewSnapshotTemplateDialog: FunctionComponent<SnapshotTemplateDialogProps> = observer((props) => {
	const { store, open, autoPopulatedImageOptions, autoPopulatedRendererOptions, autoPopulatedTemplateOptions, isCopyTemplate, selectedTemplate } = props;
	const { templateId, setImageOptions, setRendererOptions, setTemplateOptions, onCancel } = store;

	return (
		<SnapshotTemplateDialogStoreContext.Provider value={store}>
			<ModalDialog
				maxWidth="sm"
				onClose={onCancel}
				open={open ?? true}
				showClose
				showDividers
				sx={HIDE_OVERFLOW}
				titleRes="NewSnapshotTemplate"
				width="100%"
			>
				{{
					main: (
						<TemplateForm
							actions={<SaveAndCancel />} 
							autoPopulatedImageOptions={autoPopulatedImageOptions} 
							autoPopulatedRendererOptions={autoPopulatedRendererOptions}
							autoPopulatedTemplateOptions={autoPopulatedTemplateOptions}
							id={templateId}
							isCopyTemplate={isCopyTemplate}
							isTemplateAutoPopulated={false}
							selectedTemplate={selectedTemplate}
							setImageOptionsCallback={setImageOptions}
							setRendererOptionsCallback={setRendererOptions}
							setTemplateOptionsCallback={setTemplateOptions}
						/>
					),
				}}
			</ModalDialog>
		</SnapshotTemplateDialogStoreContext.Provider>
	);
});

export default NewSnapshotTemplateDialog;